export const listStyles = {
  display: "flex",
  flexDirection: "column",
  gap: { xs: 3, md: 6 },
  paddingY: { xs: 3, md: 5, lg: 9, xl: 11.75 },
  paddingX: { xs: 4, md: 6, lg: 12, xl: 20 },
  backgroundColor: "background.default",
  borderRadius: 5,
};
